/* eslint semi:0 */
import React from 'react'
import { empty, } from 'utils/rComponent'
import { mountAll, } from 'utils/rComponent'
import { canonicalUrl, isMobile, } from 'utils/ua'
import BaseComponent from 'application/baseComponent'
import { external as externalScriptLoader, } from 'utils/script'
import facebookCommentsStore from 'stores/facebookCommentsStore'
import { MOUNT_POINTS, } from 'config/preRenderedSelectorsConfig'
import facebookCommentsActions from 'actions/facebookCommentsActions'
import { facebook as facebookScriptConfig, } from 'config/externalScripts'
import { get as getFromPdo, isSupportedForDomain, } from 'application/pageDataObject'


const FACEBOOK_COMMENTS_FEATURE_ID = 'FacebookComments'
const INITIAL_NUM_COMMENTS_VISIBLE = 3

const getPostCanonicalUrl = () => getFromPdo('post.canonicalUrl', canonicalUrl)

const facebook = {
  getComments(callback){
    this.sdk(callback)
  },
  get sdk(){
    return externalScriptLoader.load({ name: facebookScriptConfig.name, })
  },
}


export class FacebookComments extends BaseComponent {

  constructor(props){
    super(props, [facebookCommentsStore, ])
  }

  getState(props){
    const {
      isFacebookCommentsShown, isFacebookCommentsLoaded, shouldLoadCommentsOnStart,
    } = facebookCommentsStore
    return {
      isShown: isFacebookCommentsShown,
      isLoaded: isFacebookCommentsLoaded,
      shouldLoadCommentsOnStart,
    }
  }

  shouldComponentUpdate(){
    if (!this.state.isShown){
      facebook.getComments(function commentsLoadedCallback(){
        setImmediate(facebookCommentsActions.facebookCommentsLoaded)
      })
    }
    return true
  }

  componentDidMount(){
    if (!this.state.shouldLoadCommentsOnStart) {
      return
    }
    facebookCommentsActions.loadFacebookComments()
  }

  get fbComments(){
    return (
      <div
        className='fb-comments'
        data-mobile={ !!isMobile }
        data-href={ getPostCanonicalUrl() }
        data-num-posts={ INITIAL_NUM_COMMENTS_VISIBLE }
      >
      </div>
    )
  }

  render(){
    return this.state.isShown ? this.fbComments : empty
  }

}

function shouldMountFacebookComments(){
  return isSupportedForDomain(FACEBOOK_COMMENTS_FEATURE_ID)
}

function mountFacebookComments(){
  return mountAll({
    [MOUNT_POINTS.FACEBOOK_COMMENTS]: <FacebookComments/>,
  })
}

export default function initFacebookComments(){
  const shouldMountFacebookCommentsComponent = shouldMountFacebookComments()
  if (shouldMountFacebookCommentsComponent) {
    mountFacebookComments()
  }
  return shouldMountFacebookCommentsComponent
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/facebookCommentsComponent.js